import React from 'react';
import { RefreshCw, Upload } from 'lucide-react';
import { T } from '../../lib/tokens';
import { Btn } from '../primitives/Btn';

export const TopBar = ({ onRefresh, loading, onOpenCommandPalette, onImportMeeting }) => {
  const now = new Date();
  const dateStr = now.toLocaleDateString('en-GB', {
    weekday: 'long', day: 'numeric', month: 'long', year: 'numeric'
  });
  return (
    <div style={{
      height: 56, flexShrink: 0,
      background: 'rgba(255,255,255,0.40)',
      backdropFilter: 'blur(32px) saturate(200%)',
      WebkitBackdropFilter: 'blur(32px) saturate(200%)',
      borderBottom: '1px solid rgba(255,255,255,0.30)',
      boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.45)',
      display: 'flex', alignItems: 'center',
      padding: '0 28px', gap: 16,
    }}>
      <div style={{ flex: 1 }}>
        <span style={{ fontSize: 13, color: T.textMuted, fontWeight: 400 }}>
          {dateStr}
        </span>
      </div>

      {/* Command palette hint */}
      <button
        onClick={onOpenCommandPalette}
        style={{
          display: 'flex', alignItems: 'center', gap: 8,
          padding: '6px 14px', borderRadius: 999,
          background: 'rgba(255,255,255,0.55)',
          border: '1px solid rgba(255,255,255,0.40)',
          boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.6), 0 1px 4px rgba(60,40,90,0.04)',
          cursor: 'pointer', fontFamily: 'inherit',
          color: T.textMuted, fontSize: 12, minWidth: 220,
          backdropFilter: 'blur(12px)',
          WebkitBackdropFilter: 'blur(12px)',
        }}
      >
        <span>Search or command...</span>
        <kbd style={{
          marginLeft: 'auto',
          fontSize: 10, fontWeight: 600, padding: '1px 6px',
          borderRadius: 4, background: 'rgba(255,255,255,0.7)',
          border: '1px solid rgba(0,0,0,0.05)',
          color: T.textMid,
        }}>⌘K</kbd>
      </button>

      {onImportMeeting && (
        <Btn small variant="ghost" onClick={onImportMeeting} title="Import a Fireflies meeting">
          <Upload size={12} />
          Import meeting
        </Btn>
      )}

      <Btn small variant="ghost" onClick={onRefresh}>
        <RefreshCw size={12} style={{ animation: loading ? 'spin 1s linear infinite' : 'none' }} />
        Refresh
      </Btn>
    </div>
  );
};
